import api from '@/api/Api'
import dateUtils from '@utils/DateUtils'

export const state = {
  aois: []
}

export const getters = {
  aois (state) {
    return state.aois
  }
}

export const mutations = {
  SET_AOI (state, newValue) {
    state.aois = newValue
  }
  // UPDATE_AOI (state, newValue) {
  //   state.aois.push(newValue)
  // }
}
export const actions = {
  afterSelectWorkspace ({ commit, dispatch, rootState }) {
    let workspaceId = rootState.auth.currentWorkspace
    dispatch('fetchAOIs', workspaceId)
  },
  fetchAOIs ({ commit, state }, workspaceID) {
    return api.getAOIs(workspaceID).then((response) => {
      const aois = response.data.data
      aois.map(val => {
        val.created_at = dateUtils.convertUTCToLocalDateTime(val.created_at)
        val.updated_at = dateUtils.convertUTCToLocalDateTime(val.updated_at)
        return val
      })
      commit('SET_AOI', aois)
      return response
    })
  },
  addAOI ({ commit, dispatch, state, rootState }, form) {
    let workspaceId = rootState.auth.currentWorkspace
    return api.addAOI(workspaceId, form).then((response) => {
      dispatch('fetchAOIs', workspaceId)
      // commit('UPDATE_AOI', response.data.data)
      return response
    })
  },
  updateAOI ({ commit, dispatch, state, rootState }, form) {
    let workspaceId = rootState.auth.currentWorkspace
    return api.updateAOI(workspaceId, form).then((response) => {
      dispatch('fetchAOIs', workspaceId)
      return response
    })
  },
  deleteAOI ({ commit, dispatch, state, rootState }, form) {
    let workspaceId = rootState.auth.currentWorkspace
    return api.deleteAOI(workspaceId, form).then((response) => {
      dispatch('fetchAOIs', workspaceId)
      return response
    })
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/aoi.js